import "./App.css"; 
import Paint from "./Paint";

import { script } from "./script";
import { jscolor } from "./jscolor";
function App() {
  return (
   <Paint/> 
  );
}

export default App;
